module.exports = __webpack_public_path__ + "static/media/toc-mockup-font-examples.ddb8ceed.jpg";